import React from 'react';
import { useHistory } from 'react-router-dom';
import { FiAlertTriangle, FiAlertCircle, FiCreditCard, FiX } from 'react-icons/fi';

const SubscriptionBanner = ({ type, message, onDismiss, canManageBilling }) => {
  const history = useHistory();

  const styles = {
    pending: {
      wrapper: 'bg-blue-50 border-blue-300 text-blue-800',
      icon: <FiCreditCard className="w-5 h-5 text-blue-600 flex-shrink-0" />,
      button: 'bg-blue-600 hover:bg-blue-700 text-white',
    },
    grace: {
      wrapper: 'bg-yellow-50 border-yellow-300 text-yellow-800',
      icon: <FiAlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0" />,
      button: 'bg-yellow-600 hover:bg-yellow-700 text-white',
    },
    restricted: {
      wrapper: 'bg-orange-50 border-orange-300 text-orange-800',
      icon: <FiAlertCircle className="w-5 h-5 text-orange-600 flex-shrink-0" />,
      button: 'bg-orange-600 hover:bg-orange-700 text-white',
    },
  };

  const style = styles[type];
  if (!style) return null;

  return (
    <div className={`${style.wrapper} border-b-2 px-4 md:px-10 py-3`} role="alert">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          {style.icon}
          <p className="text-sm font-medium">{message}</p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          {canManageBilling && (
            <button
              onClick={() => history.push('/billing')}
              className={`${style.button} text-sm font-medium rounded-full px-4 py-1.5 transition-colors`}
            >
              Pay Now
            </button>
          )}
          {!canManageBilling && (
            <span className="text-xs opacity-75">Contact your administrator</span>
          )}
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="p-1 rounded-full hover:bg-black hover:bg-opacity-10 transition-colors"
              aria-label="Dismiss"
            >
              <FiX className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBanner;
